// export const username = new RegExp('^[A-Za-z0-9_#!%-_*/]*$');
// export const emailId = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}');
// export const accountingCode = new RegExp('^[A-Za-z0-9 #!%-_*/]*$');
// export const name = new RegExp('^[A-Za-z0-9 #!%-_*/]*$');
// export const onlyNumeric = new RegExp('^[0-9]*$');
// export const onlyAlphabets = new RegExp('^[A-Za-z ]*$');
// // export const mobile = new RegExp('^[0-9]{10}$');
// export const mobile = new RegExp('^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}$');
// export const postCode = new RegExp('^[A-Z0-9a-z]{3} [A-Z0-9a-z]{3}$');
// //export const canadaPostCode = new RegExp('^[A-Z0-9a-z]{3} [A-Z0-9a-z]{3}$');
// export const canadaPostCode = new RegExp('^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$');
// export const usaPostCode = new RegExp('^[0-9]{5}(-[0-9]{4})?$');
// export const quantity = new RegExp('^[0-9]{1,4}$');
// export const msgSubject = new RegExp('^[A-Za-z0-9 _.@,#!%\\-$_*/]*$');

export const username = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9_’'#!%\\-*/]*$");
export const accountingCode = new RegExp(
  "^[A-Za-zÀ-ÖØ-öø-ÿ0-9_’'#!%\\-*/\\s]*$"
);
// export const name = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9_’'#!%\\-*/\\s]*$");
export const name = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ0-9&.,()'’_#%/\\-\\s]+$");
export const emailId = new RegExp(
  "^[A-Za-zÀ-ÖØ-öø-ÿ0-9._%+\\-']+@[A-Za-zÀ-ÖØ-öø-ÿ0-9.-]+\\.[A-Za-zÀ-ÖØ-öø-ÿ]{2,}$"
);
export const onlyNumeric = new RegExp('^[0-9]*$');
export const onlyAlphabets = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ ']*$");
// export const mobile = new RegExp('^[0-9]{10}$');
export const mobile = new RegExp('^\\([0-9]{3}\\)-[0-9]{3}-[0-9]{4}$');
export const postCode = new RegExp('^[A-Z0-9a-z]{3} [A-Z0-9a-z]{3}$');
//export const canadaPostCode = new RegExp('^[A-Z0-9a-z]{3} [A-Z0-9a-z]{3}$');
export const canadaPostCode = new RegExp(
  '^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$'
);
export const usaPostCode = new RegExp('^[0-9]{5}(-[0-9]{4})?$');
export const quantity = new RegExp('^[0-9]{1,4}$');
export const msgSubject = new RegExp('^[A-Za-zÀ-ÖØ-öø-ÿ0-9 _.@,#!%\\-$_*/]*$');
